
const digest = 'a968947b8e637e132db625f2c4b52b7a12b91111efd127460e1670fef1512777';
const classes = {"disabledCollapse":"_disabledCollapse_1tm8q_1","header":"_header_1tm8q_1","content":"_content_1tm8q_4","collapse":"_collapse_1tm8q_8","planInfo":"_planInfo_1tm8q_12","planInfoName":"_planInfoName_1tm8q_21","planInfoItem":"_planInfoItem_1tm8q_25","wrapper":"_wrapper_1tm8q_32","continueButtonInCase":"_continueButtonInCase_1tm8q_37","continueButtonInTreatment":"_continueButtonInTreatment_1tm8q_41","continueButtonInDefault":"_continueButtonInDefault_1tm8q_45","main":"_main_1tm8q_49"};
const css = `._disabledCollapse_1tm8q_1 ._header_1tm8q_1 {
  background-color: #f8f8f8;
}
._disabledCollapse_1tm8q_1 ._content_1tm8q_4 {
  padding: 21px;
}

._collapse_1tm8q_8 ._content_1tm8q_4 {
  padding: 21px;
}

._planInfo_1tm8q_12 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 40px;
  background-color: #eaedf3;
  color: #000;
  padding: 12px 24px;
}
._planInfo_1tm8q_12 ._planInfoName_1tm8q_21 {
  font-size: 16px;
  font-weight: 500;
}
._planInfo_1tm8q_12 ._planInfoItem_1tm8q_25 {
  font-size: 14px;
}
._planInfo_1tm8q_12 ._planInfoItem_1tm8q_25 span {
  color: #626262;
}

._wrapper_1tm8q_32 {
  position: relative;
  background: #ffffff;
}

._continueButtonInCase_1tm8q_37 {
  right: 450px;
}

._continueButtonInTreatment_1tm8q_41 {
  right: 285px;
}

._continueButtonInDefault_1tm8q_45 {
  right: 0;
}

._main_1tm8q_49 {
  font-family: Rubik, "sans-serif";
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  